import { TFunction } from "i18next";
import * as yup from "yup";

export interface ManualStatusChangeValidationSchemeProps {
  t: TFunction;
}

export const ManualStatusChangeValidationScheme = ({
  t,
}: ManualStatusChangeValidationSchemeProps) => {
  const requiredMsg = t("validations.required");

  return yup.object().shape({
    newStatusId: yup
      .number()
      .transform((value) => (isNaN(value) ? undefined : value))
      .required(requiredMsg)
      .test("newStatusId", requiredMsg, (val) => !!val && val > 0),
    description: yup.string().trim().required(requiredMsg),
  });
};
